import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/downloads/DownloadPrototyping'

const Download: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'プロトタイピング プロトタイプ コンセプト デザイン テクニカル ユーザー検証'}
        image={'https://aitria.co.jp/images/img/download/prototyping/ogp.png'}
        url={'https://aitria.co.jp/download/prototyping/'}
        title="プロトタイピングサービス | 資料ダウンロード | Aitria（アイトリア）"
        description="3つのプロトタイプ（コンセプトプロトタイプ、デザインプロトタイプ、テクニカルプロトタイプ）の目的や解決できる課題の違い、活用例などをまとめた全16ページの資料です。"
      />
      <Template />
    </>
  )
}

export default Download
